import { render, staticRenderFns } from "./SupportTicketListItem.vue?vue&type=template&id=58380e16&scoped=true&"
import script from "./SupportTicketListItem.vue?vue&type=script&lang=js&"
export * from "./SupportTicketListItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketListItem.vue?vue&type=style&index=0&id=58380e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58380e16",
  null
  
)

export default component.exports